// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__H0HPD","logoImage":"logo_logoImage__EfNcl","svg":"logo_svg__0f8jy","path":"logo_path__6rLEn","dash":"logo_dash__t3JfR"};